// Referral tab: the external purchase button (BookEmbedButtonEditor) — a
// live preview of aldoo-button.js and the embed code to copy.
import React, { useEffect, useRef, useState } from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { showNotification } from "aldoo-ra/Notification"
import useProductEditorTexts from "aldoo-ra/CMSModels/StoreProduct/useProductEditorTexts"

const SCRIPT_ID = "EmbedAldooBooksBuyButton"
const SCRIPT_SRC = "https://aldoo.com/static/js/aldoo-button.js"

const embedCode = (pid, language) => `<script async defer src="${SCRIPT_SRC}" ></script>
<script>
AldooStart = ()=> AldooButton ({
    target: "#com-aldoo-books-button",
    pid: "${pid}",
    language: "${language}"
})
</script>
<div id="com-aldoo-books-button"></div>`

// the button speaks the language picked at the top of the product dialog
export default function ReferralTab({ pid, editor }) {
  const language = editor?.language || "en"
  const container = useRef(null)
  const [loaded, setLoaded] = useState(false)
  const t = useProductEditorTexts()

  useEffect(() => {
    if (typeof document === "undefined") return
    const render = () => {
      if (!window.AldooButton || loaded) return
      setLoaded(true)
      try {
        window.AldooButton({ target: "#com-aldoo-books-button", pid, language })
      } catch (_) {}
    }
    if (document.getElementById(SCRIPT_ID)) return render()
    const js = document.createElement("script")
    js.id = SCRIPT_ID
    js.src = SCRIPT_SRC
    js.async = true
    js.onload = render
    container.current?.appendChild(js)
  }, [])

  const copy = async () => {
    await navigator.clipboard?.writeText(embedCode(pid, language))
    showNotification({ message: t`Button code copied`, className: "bg-admin_success text-white" })
  }

  return (
    <div className="border border-admin_bordered rounded-lg bg-admin_paper">
      <div className="p-4 flex flex-col gap-3">
        <Typography component="h4" variant="admin_h4" className="my-0">{t`External Purchase Code`}</Typography>
        <div ref={container} className="w-[350px] h-[35px]">
          <div id="com-aldoo-books-button" />
        </div>
        <pre className="text-xs bg-admin_neutral_1 rounded p-3 overflow-auto my-0" data-testid="embed-code">{embedCode(pid, language)}</pre>
      </div>
      <div className="flex justify-end items-center gap-2 px-4 pb-4">
        <Button variant="admin_secondary" className="h-[32px] text-xs px-3" onClick={copy}>{t`Copy Code`}</Button>
      </div>
    </div>
  )
}
